<app-alert alertType="danger" *ngIf="!readonly && hasErrors">
    {{ 'PRODUCT.CONFIGURE_PROPERTY_AGAIN' | translate }}
</app-alert>

<div class="box box-white has-shadow" *ngIf="!readonly || hasFinishedConfiguration">
    <div class="box-header box-body">

        <div class="box-header-icon">
            <i class="icon-home"></i>
        </div>

        <div class="box-header-title">
            {{ 'OFFER_CONFIG.WELTH' | translate }}
        </div>

        <div *ngIf="!hasFinishedConfiguration && !readonly" class="box-action text-accent">
            <button class="btn btn-link btn-slim"
                    (click)="configure()">
                <i class="icon-settings mr-2"></i>
                <span>{{'CONFIGURE' | translate }}</span>
            </button>
        </div>

        <div *ngIf="hasFinishedConfiguration && readonly" class="box-action text-accent">
            <button class="btn btn-link btn-slim"
                    (click)="preview()">
                <i class="icon-preview mr-2"></i>
                <span>{{'PREVIEW' | translate }}</span>
            </button>
        </div>
    </div>

    <div class="box-content" *ngIf="hasFinishedConfiguration">
        <div class="box-body">
            <div class="box-row has-padding">
                <div class="box-item">
                    <div class="row">
                        <div class="col-3">
                            <app-output [label]="'OFFER_CONFIG.PROTECTION_PERIOD' | translate">
                                {{ configuration.insuranceStartDate | lsnDate }}
                                - {{ configuration.insuranceEndDate | lsnDate }}
                            </app-output>
                        </div>
                        <div class="col-2">
                            <app-output [label]="'OFFER_CONFIG.ESTATE_TYPE' | translate">
                                {{ configuration.propertyType.description }}
                            </app-output>
                        </div>
                        <div class="col">
                            <app-output [label]="'INSURED_OBJECT' | translate">
                                {{ configuration.address.fullAddress }}
                            </app-output>
                        </div>
                        <div class="col-12">
                            <app-output [label]="'OFFER_CONFIG.INSURANCE_COVERAGE' | translate">
                                {{ insuranceScope }}
                            </app-output>
                        </div>
                    </div>
                </div>
                <div class="box-item box-item-action align-self-center justify-content-end" *ngIf="!readonly">
                    <div class="col-auto">
                        <button class="btn btn-link btn-slim"
                                (click)="delete()"
                                [matTooltip]="'TOOLTIP.DELETE_PRODUCT' | translate">
                            <i class="icon-delete mr-1"></i>
                        </button>


                        <button class="btn btn-link btn-slim"
                                (click)="configure()"
                                [matTooltip]="'TOOLTIP.EDIT_PRODUCT' | translate">
                            <i class="icon-edit"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="box-footer" *ngIf="hasFinishedConfiguration">
        <div class="box-body">
            <div class="row no-gutters">
                <div class="installment" *ngIf="configuration?.paymentDefinition.installmentList">
                    <div class="installment-title">
                        {{ 'OFFER_CONFIG.PAYMENTS' | translate }}
                    </div>

                    <div class="installment-body">
                        <div class="installment-item"
                             *ngFor="let element of configuration?.paymentDefinition.installmentList">
                            <div class="item-price">{{ element.amount | premium}}</div>
                            <div class="item-date">{{ element.date | lsnDate}}</div>
                        </div>
                    </div>
                </div>

                <div class="col"></div>

                <div class="text-price column">
                    <div class="item-text">{{ 'LABEL.PREMIUM' | translate }}</div>
                    <div class="item-price">{{ configuration.premium | premium }}</div>
                </div>
            </div>
        </div>
    </div>
</div>

